import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../core/domain/events/domain_event_provider';
import { TaskEvent } from './task_events';

@Injectable({ providedIn: 'root' })
export class TaskEventProvider extends DomainEventProvider<TaskEvent> {}
